import _classCallCheck from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React, { PropTypes } from 'react';
import styles from '../../build/styles';
import { getCallbacks } from '../helper/helper';
import DataComponent from '../dataComponent';

var Button =
/*#__PURE__*/
function (_DataComponent) {
  _inherits(Button, _DataComponent);

  function Button() {
    _classCallCheck(this, Button);

    return _possibleConstructorReturn(this, _getPrototypeOf(Button).apply(this, arguments));
  }

  _createClass(Button, [{
    key: "createClassName",
    value: function createClassName() {
      return [styles.button, styles[this.props.size], styles[this.props.color], styles[this.props.buttonStyle], styles[this.props.state], this.props.delete ? styles.delete : '', this.props.className].join(' ').trim();
    }
  }, {
    key: "createIconSize",
    value: function createIconSize() {
      if (this.props.size === 'isLarge') return 'isMedium';
      if (this.props.size === 'isSmall') return 'isSmall';
      return '';
    }
  }, {
    key: "renderLeftIcon",
    value: function renderLeftIcon() {
      return React.createElement('span', null, React.createElement('span', {
        className: [styles.icon, styles[this.createIconSize()]].join(' ')
      }, React.createElement('i', {
        className: [styles.fa, this.props.icon].join(' ')
      })), React.createElement('span', {
        style: {
          lineHeight: this.props.size === 'isLarge' ? '32px' : 'auto'
        }
      }, this.props.children));
    }
  }, {
    key: "renderRightIcon",
    value: function renderRightIcon() {
      return React.createElement('span', null, React.createElement('span', {
        style: {
          lineHeight: this.props.size === 'isLarge' ? '32px' : 'auto'
        }
      }, this.props.children), React.createElement('span', {
        className: [styles.icon, styles[this.createIconSize()]].join(' ')
      }, React.createElement('i', {
        className: [styles.fa, this.props.icon].join(' ')
      })));
    }
  }, {
    key: "renderIcon",
    value: function renderIcon() {
      return this.props.isIconRight ? this.renderRightIcon() : this.renderLeftIcon();
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement('button', _extends({}, getCallbacks(this.props), {
        style: this.props.style,
        className: this.createClassName()
      }, this.dataProps()), React.createElement('span', null, this.props.icon ? this.renderIcon() : this.props.children));
    }
  }]);

  return Button;
}(DataComponent);

export { Button as default };
Button.propTypes = {
  children: PropTypes.string,
  className: PropTypes.string,
  icon: PropTypes.string,
  type: PropTypes.string,
  style: PropTypes.object,
  size: PropTypes.oneOf(['isSmall', 'isMedium', 'isLarge']),
  color: PropTypes.oneOf(['isPrimary', 'isInfo', 'isSuccess', 'isWarning', 'isDanger', 'isLink', 'isWhite', 'isLight', 'isDark', 'isBlack', 'isLink']),
  buttonStyle: PropTypes.oneOf(['isOutlined', 'isInverted']),
  state: PropTypes.oneOf(['isLoading', 'isActive', 'isDisabled']),
  delete: PropTypes.bool,
  isIconRight: PropTypes.bool,
  data: PropTypes.array
};
Button.defaultProps = {
  style: {},
  className: ''
};